module.exports = __webpack_public_path__ + "img/nicky-smc.c9448d3b.jpg";